import ROUTE_NAMES from '@/app/admin/router/router-const';

export default [
  {
    path: 'landing',
    name: ROUTE_NAMES.LOGIN_LANDING,
    component: () => import('../LandingLoginPage.vue'),
  }
];